import { createTheme, responsiveFontSizes } from '@mui/material/styles'
// import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
// import { ThemeProvider as JssThemeProvider, StylesProvider } from '@mui/styles'

// Theme localization: https://mui.com/material-ui/guides/localization/
import * as locales from '@mui/material/locale'

import { LOCALE_DEFAULT } from '../../i18n/constants'
import { MATERIAL_COMPONENTS_OVERRIDES } from './overrides'
import { APP_THEME_COLORS } from './colors'

// Default theme: https://material-ui.com/customization/default-theme/
export let theme = responsiveFontSizes(
  createTheme(
    {
      components: {
        ...MATERIAL_COMPONENTS_OVERRIDES,

        MuiSelect: {
          defaultProps: {
            MenuProps: {
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              sx: {
                '& .MuiPaper-root': {
                  transformOrigin: 'left top !important',
                },
                '& .MuiList-root': {
                  textAlign: 'left',
                },
              },
            },
          },
        },
      },
      palette: {
        primary: {
          main: APP_THEME_COLORS[30],
          contrastText: APP_THEME_COLORS[10],
        },
        secondary: {
          main: APP_THEME_COLORS[40],
          contrastText: APP_THEME_COLORS[20],
        },
        DataGrid: {
          // Container background
          bg: 'rgba(255,136,0,0.53)',
          // Pinned rows and columns background
          pinnedBg: '#ff8800',
          // Column header background
          headerBg: '#df0000',
        },
      },
      typography: {
        fontFamily: 'FSEmeric-Regular',
        h4: {
          fontFamily: 'FSEmeric-Medium',
        },
        h5: {
          fontFamily: 'FSEmeric-Medium',
        },
        h6: {
          fontFamily: 'FSEmeric-Medium',
          lineHeight: 1,
        },
        subtitle1: {
          fontFamily: 'FSEmeric-Medium',
          lineHeight: 1.25,
        },
        subtitle2: {
          fontFamily: 'FSEmeric-Medium',
        },
        body1: {
          lineHeight: 1.25,
        },
      },
    },
    locales[LOCALE_DEFAULT.replace('-', '')]
  )
)
